<script setup>
import { useTheme } from 'vuetify'
import ScrollToTop from '@core/components/ScrollToTop.vue'
import { useThemeConfig } from '@core/composable/useThemeConfig'
import { hexToRgb } from '@layouts/utils'
import { connectSocket, disconnectSocket } from '@/services/SocketService'
import { useNotifications } from '@core/composable/useNotifications'
import { NotificationToast, CriticalBanner } from '@/components/sensando'

const {
  syncInitialLoaderTheme,
  syncVuetifyThemeWithTheme: syncConfigThemeWithVuetifyTheme,
  isAppRtl,
  handleSkinChanges,
} = useThemeConfig()

const { global } = useTheme()

// ℹ️ Sync current theme with initial loader theme
syncInitialLoaderTheme()
syncConfigThemeWithVuetifyTheme()
handleSkinChanges()

// Auto-connect socket if user is authenticated
const token = localStorage.getItem('token')
if (token) {
  //connectSocket()
}

// Global notification engine — listens to socket events
const notifications = useNotifications()
if (token) {
  notifications.startListening()
}
</script>

<template>
  <VLocaleProvider :rtl="isAppRtl">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <RouterView :key="$route.fullPath"/>
      <ScrollToTop />

      <!-- Global Notification Layer -->
      <NotificationToast
        :toasts="notifications.toasts.value"
        @dismiss="notifications.dismissToast"
        @click="notifications.dismissToast($event.id)"
      />
      <CriticalBanner
        :alerts="notifications.criticalAlerts.value"
        :muted="notifications.muted.value"
        @acknowledge="notifications.acknowledge($event, 'acknowledged')"
        @escalate="notifications.acknowledge($event, 'escalated')"
        @toggle-mute="notifications.toggleMute()"
      />
    </VApp>
  </VLocaleProvider>
</template>
